import React from 'react'

import Card from '@material-ui/core/Card'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

import { useThemedStyles } from '../hooks/useThemedStyles'

import EndedHeaderBackground from '../../assets/images/legadosemente-header-background.png'

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    [theme.breakpoints.up('md')]: {
      marginTop: theme.spacing(4),
    },
  },
  card: {
    [theme.breakpoints.down('sm')]: {
      borderRadius: 0,
    },
  },
  cardHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'flex-start',
    position: 'relative',
  },
  registrationLogoImage: {
    width: '100%',
  },
})

const EndedScreen = (props) => {
  const classes = useThemedStyles(styles)

  return (
    <Grid className={classes.root} container>
      <Grid item xs={12}>
        <Grid container justify="center">
          <Grid item md={8} lg={6}>
            <Card className={classes.card}>
              <div>
                <div className={classes.cardHeader}>
                  <img
                    alt="logo"
                    className={classes.registrationLogoImage}
                    src={EndedHeaderBackground}
                  />
                </div>
              </div>

              <CardContent>
                <React.Fragment>
                  <Typography
                    gutterBottom
                    variant="h5"
                    component="h2"
                    color="primary"
                  >
                    Olá!
                  </Typography>

                  <br />

                  <Typography variant="body2" component="p">
                    Agradecemos seu interesse no <b>Legado Semente</b>.
                    Infelizmente, as inscrições já foram encerradas.
                  </Typography>
                </React.Fragment>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default EndedScreen
